import React from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const MaliciousContentMessage = () => {
  return (
    <div className='malicious-content-container'>
      <img
        src={getStaticImage('/icons/orange-brand/icon-block-red.svg')}
        alt={'blocked'}
        className='malicious-content-container__icon'
      />
      <label className='malicious-content-container__text malicious-content-container__text--title'>
        {lang('dashboard_malicious-content-title')}
      </label>
      <span className='malicious-content-container__text'>{lang('dashboard_malicious-content-legend')}</span>
    </div>
  )
}

export default MaliciousContentMessage